import React from 'react';

import { Auth0Provider, Auth0ProviderOptions } from '@auth0/auth0-react';
import { EquipUIProvider, Fonts } from '@equip.health/ui';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import App from '~/App';
import {
  VITE_AUTH0_AUDIENCE,
  VITE_AUTH0_CLIENT_ID,
  VITE_AUTH0_DOMAIN,
} from '~/lib/constants/env';
import { AnalyticsProvider } from '~/lib/contexts/AnalyticsContext';
import AppSyncContextProvider from '~/lib/contexts/AppSyncContext';
import { ModeContextProvider } from '~/lib/contexts/ModeContext';
import store from '~/store';
import { ReduxSecurityWrapper } from '~/store/security';

import { buildProvidersTree } from './lib/util/providerTree.util';

export const WrappingContexts = () => {
  const auth0ProviderOptions: Auth0ProviderOptions = {
    authorizationParams: {
      audience: VITE_AUTH0_AUDIENCE,
      redirect_uri: window.location.origin,
    },
    cacheLocation: 'localstorage',
    clientId: VITE_AUTH0_CLIENT_ID,
    domain: VITE_AUTH0_DOMAIN,
    useRefreshTokens: true,
  };

  const ProvidersTree = buildProvidersTree([
    [Auth0Provider, auth0ProviderOptions],
    [ReduxSecurityWrapper, {}],
    [Provider, { store }],
    [EquipUIProvider, { themeType: 'firefly_v2' }],
    [Router, {}],
    [AnalyticsProvider, {}],
    [ModeContextProvider, {}],
    [AppSyncContextProvider, {}],
  ]);

  return (
    <React.StrictMode>
      <ProvidersTree>
        <Fonts />
        <App />
      </ProvidersTree>
    </React.StrictMode>
  );
};
